import React, { useState, useEffect } from "react";
import { Dropdown, Menu, Space } from "antd";
import { DownOutlined, UpOutlined } from "@ant-design/icons";

import { ReactComponent as PencilIcon } from "../../../../assets/svg/pencil.svg";
// @ts-ignore
import { getPredefinedMetrics } from "../../../../modules/actions/PlanActions";

import { useSelector, useDispatch } from "react-redux";
// @ts-ignore
import classes from "./styled.module.scss";
import { useLocation } from "react-router-dom";
interface CustomSelectProps {
  onAddMetric: () => void;
  selectedValue: any;
  setSelectedValue: any;
  selectedUnit: any;
  setSelectedUnit: any;
  setIsAddMetric: any;
  isFullWidth?: boolean;
}

const SelectMetric: React.FC<CustomSelectProps> = ({
  onAddMetric,
  selectedValue,
  setSelectedValue,
  selectedUnit,
  setSelectedUnit,
  setIsAddMetric,
  isFullWidth = false,
}) => {
  const { pathname } = useLocation();
  const isShared = pathname.includes("shared-project");
  const dispatch = useDispatch();
  const { planDetails } = useSelector((state: any) => state.plan.plan);
  const getMetric = useSelector((state: any) => state?.plan?.predefinedMetrics);

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [dropdownHeight, setDropdownHeight] = useState("40vh");

  useEffect(() => {
    if (!isShared) {
      dispatch(getPredefinedMetrics());
    }
  }, []);

  useEffect(() => {
    const updateDropdownHeight = () => {
      const triggerElement = document.querySelector(
        ".measurement-popover-overlay"
      );
      const triggerRect = triggerElement?.getBoundingClientRect();
      const availableHeight =
        window.innerHeight - (triggerRect?.bottom || 0) - 20;
      const height =
        Math.max(availableHeight, 100) > 200
          ? 200
          : Math.max(availableHeight, 100);
      setDropdownHeight(`${height}px`);
    };

    const handleViewportChange = () => {
      setIsDropdownOpen(false);
      updateDropdownHeight();
    };

    updateDropdownHeight();

    window.addEventListener("resize", handleViewportChange);
    window.addEventListener("orientationchange", handleViewportChange);

    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", handleViewportChange);
    }

    return () => {
      window.removeEventListener("resize", handleViewportChange);
      window.removeEventListener("orientationchange", handleViewportChange);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener(
          "resize",
          handleViewportChange
        );
      }
    };
  }, []);

  const capitalizeFirstLetter = (word: string) => {
    return word.charAt(0).toUpperCase() + word.slice(1);
  };

  const transformedItems = Array.isArray(getMetric)
    ? getMetric.map((item: any) => ({
        key: item?.label,
        label: capitalizeFirstLetter(item?.label),
        children: Array.isArray(item.metric_units)
          ? item.metric_units.map((unit: any) => ({
              key: unit?.name,
              label: unit?.name,
              onClick: () => {
                setSelectedValue({
                  label: item?.name,
                  unit: unit?.name,
                  unitId: unit?.id,
                });

                setSelectedUnit(item?.name);
                setIsDropdownOpen(false);
              },
            }))
          : [],
      }))
    : [];

  const transformedLabels =
    planDetails?.goal?.custom_labels?.map((label: any) => ({
      key: label.id,
      label: label.value,
      unitId: label.id,

      children: label.custom_unit_options.map((item: any) => ({
        key: item.id,
        label: item.value,
        onClick: () => {
          setSelectedValue({
            label: item?.value,
            unit: item?.value,
            unitId: item?.id,
            isCustom: true,
          });

          setSelectedUnit(item?.value);
          setIsDropdownOpen(false);
        },
      })),
    })) || [];

  const handleAddMetricClick = (event: any) => {
    event.stopPropagation();
    onAddMetric();
    setIsDropdownOpen(false);
  };

  const menuItems = [
    ...transformedItems,
    transformedLabels.length > 0 && {
      key: "customMetricsHeading",

      label: (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: 0,
          }}
        >
          <span
            style={{
              color: "#112538",
              fontSize: 10,
              fontWeight: "bold",
              cursor: "default",
            }}
          >
            Custom Metrics
          </span>
          <PencilIcon
            style={{ marginRight: "-10px" }}
            className="cursor-pointer"
            onClick={(e: any) => {
              handleAddMetricClick(e), setIsAddMetric(true);
            }}
          />
        </div>
      ),
      type: "group",
    },
    ...transformedLabels.map((unit: any) => ({
      key: unit.key,
      label: unit.label,
      children: unit.children,
    })),
  ];

  return (
    <Dropdown
      menu={{
        items: menuItems,
        style: {
          maxHeight: dropdownHeight,
          overflowY: "auto",
        },
      }}
      trigger={["click"]}
      placement="bottomLeft"
      autoAdjustOverflow
      open={isDropdownOpen}
      overlayClassName={classes.customDropdownMenu}
      onOpenChange={(open) => setIsDropdownOpen(open)}
      getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
      dropdownRender={(menu) => (
        <>
          <div className={classes.inner}>{menu}</div>
          <div className={classes.lastItem}>
            <span
              onClick={handleAddMetricClick}
              style={{
                color: "#1271A6",
                cursor: "pointer",
                textAlign: "right",
              }}
            >
              + Add Metric
            </span>
          </div>
        </>
      )}
    >
      <a onClick={(e) => e.preventDefault()}>
        <Space
          className={`${classes.dropdownTrigger} ${
            isFullWidth ? classes.fullWidth : ""
          }`}
        >
          <span>{selectedUnit || selectedValue?.unit || "--"}</span>
          {isDropdownOpen ? <UpOutlined /> : <DownOutlined />}
        </Space>
      </a>
    </Dropdown>
  );
};

export default SelectMetric;
